<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">操作日志</span>
    </div>

    <div style="padding:20px 20px 0px">
      <div class="flex_between_nowrap" style="margin-bottom:30px">
        <div>
          <el-date-picker
            v-model="pickerArr"
            type="daterange"
            @change="pickerChange"
            align="right"
            unlink-panels
            size="small"
            value-format="yyyy-MM-dd"
            class="input36"
            style="width:300px;margin-right:20px;"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="{
              disabledDate(time) {
                return time.getTime() >= Date.now() - 12 * 60 * 60 * 1000;
              },
              shortcuts: [
                {
                  text: '最近一周',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                  },
                },
                {
                  text: '最近一个月',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                  },
                },
                {
                  text: '最近三个月',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                  },
                },
              ],
            }"
          >
          </el-date-picker>
          <el-input
            v-model="params['userName']"
            size="small"
            clearable
            @focus="selectFoucs"
            style="width:200px;"
            placeholder="请选择用户"
          >
          </el-input>
        </div>
        <el-input
        clearable
          size="small"
          v-model="params['search']"
          style="width:300px;"
          placeholder="请输入用户操作类型"
        >
          <i
            slot="suffix"
            class="el-icon-search inputIcon "
            @click.stop="tableSearch"
          ></i>
        </el-input>
      </div>

      <x-table
        url="/pc/log/operate/log"
        :axiosType="true"
        ref="xTable"
        :params="params"
      >
        <el-table-column
        show-overflow-tooltip
          v-for="(item, index) in columnArr"
          :label="item.label"
          :prop="item.model"
          :key="index"
        >
        </el-table-column>
      </x-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columnArr: [
        {
          label: "操作时间",
          model: "createTime",
        },
        {
          label: "业务名称",
          model: "lTitle",
        },
        {
          label: "操作类型",
          model: "lType",
        },
        {
          label: "业务内容",
          model: "lValue",
        },
        {
          label: "操作人",
          model: "createName",
        },
      ],
      params: {},
      pickerArr: [],
    };
  },
  mounted() {},
  methods: {
    accountCallBack(data) {
      if (data.id) {
        this.$set(this.params, "userId", data.id);
        this.$set(this.params, "userName", data.staffName);
      } else {
        this.$set(this.params, "userId", "");
        this.$set(this.params, "userName", "");
      }
      this.tableSearch();
    },
    selectFoucs() {
      this.$createDialog(this, {
        dialogConfig: { title: "选择人员", width: "50%" },
        namespace: "select_account",
        whetherDestruction: true,

        assemblyConfig: {
          selectType: "radio",
          callBack: this.accountCallBack,
        },
      });
    },
    tableSearch() {
      setTimeout(() => {
        this.$refs.xTable.search();
      });
    },
    pickerChange(data) {
      if (data) {
        this.$set(this.params, "startTime", data[0]);
        this.$set(this.params, "endTime", data[1]);
        this.tableSearch();
      } else {
        this.$set(this.params, "startTime", "");
        this.$set(this.params, "endTime", "");
        this.tableSearch();
      }
    },
  },
};
</script>
<style scoped></style>
